import fetch from '@/utils/fetch';
// 直播列表
export function liveList(data = {}) {
  return fetch({
    url: `/saas/live/m/s/live/list`,
    method: 'post',
    data,
  });
}
// 直播创建
export function liveCreate(data = {}) {
  return fetch({
    url: `/saas/live/m/s/live/create`,
    method: 'post',
    data,
  });
}
// 直播编辑
export function liveUpdate(data = {}) {
  return fetch({
    url: `saas/live/m/s/live/update`,
    method: 'post',
    data,
  });
}
// 直播详情
export function liveView(data = {}) {
  return fetch({
    url: `/saas/live/m/s/live/view`,
    method: 'post',
    data,
  });
}

// 关联商品 关联拍品
export function relateType(data = {}) {
  return fetch({
    url: `/saas/live/m/s/live/good/relate`,
    method: 'post',
    data,
  });
}
// 关联list
export function relateList(data = {}) {
  return fetch({
    url: `/saas/live/m/s/live/good/list`,
    method: 'post',
    data,
  });
}

// 关联类型
export function liveType(data = {}) {
  return fetch({
    url: `/saas/live/m/s/live/type`,
    method: 'post',
    data,
  });
}